<template>
  <div class="add-project">
    <a-form :form="form" :label-col="labelCol" :wrapper-col="wrapperCol">
      <a-form-item label="项目标题" class="add-project-form-item">
        <a-input
          class="add-project-input"
          v-decorator="[
            'title',
            { rules: [{ required: true, message: '请输入项目标题' }] },
          ]"
        />
      </a-form-item>
      <a-form-item label="项目编码" class="add-project-form-item">
        <a-input
          class="add-project-input"
          v-decorator="[
            'name',
            { rules: [{ required: true, message: '请输入大写驼峰格式的项目编码,如：TestProject' }], pattern: /^[A-Z][a-zA-Z0-9]{1,}$/g },
          ]"
          @blur="validProjectCode"
        />
      </a-form-item>

      <a-form-item label="项目框架" class="add-project-form-item">
        <!-- v-decorator="['frameworkId', { rules: [{ required: true, message: '请选择框架' }] }]" -->
        <a-cascader 
          :display-render="displayRender"
          v-decorator="['frameworkId', { rules: [{ required: true, message: '请选择框架' }] }]"
          :fieldNames="{label: 'name', value: 'id', children: 'children'}" 
          placeholder="请选择项目框架" 
          :options="frameworkOptions" change-on-select />
        <!-- <a-select class="add-project-input" :options="optionsFramework" /> -->
      </a-form-item>
      <a-form-item label="项目版本号" class="add-project-form-item">
        <a-input
          v-decorator="['version']"
        />
      </a-form-item>
      <a-form-item label="项目描述" class="add-project-form-item">
        <a-input
          class="add-project-textarea"
          type="textarea"
          v-decorator="['description']"
        />
      </a-form-item>

      <a-form-item label="标签" class="add-project-form-item">
        <SelectTags
          @getTags="handleChange"
          @tagFocus="getTagParams"
          :queryParams="tagParams"
          defaultSize="large"
        />
      </a-form-item>
      <a-form-item
        label="项目权限"
        class="add-project-form-item radioGroup__style"
      >
        <PermissionsChoose @selectRido="getRidoVal" @buy="getBuy" />
      </a-form-item>

      <div class="add-project-bottom">
        <a-button
          class="add-project-button"
          type="danger"
          @click="onSubmit"
          :loading="addloading"
        >
          添加
        </a-button>
      </div>
    </a-form>
  </div>
</template>

<script>
import projectApi from "@/request/api-manager/project.js";
import frameworkApi from "@/request/api-manager/framework.js";
import { USER_ID } from "@/store/mutation-types";
import SelectTags from "./project/list/components/SelectTags";
import PermissionsChoose from "@/views/component/permissionsChoose/index";
export default {
  name: "add-project",
  components: {
    SelectTags,
    PermissionsChoose,
  },
  data() {
    return {
      selectTag: [],
      size: "default",
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
      chooseTag: [],
      tags: [],
      other: "",
      frameworkOptions: [],
      frameworkList: [],
      form: this.$form.createForm(this, "options"),
      addProjectParams: {
        sysUserId: this.$ls.get(USER_ID), // 用户id
        title: undefined, // 中文名称
        status: 0, // 0为公开，1为私有
        name: undefined, // 英文简称
        description: undefined, // 描述
        params: undefined, // 参数
        img: undefined, // 图片
      },
      tagParams: {},
      addloading: false,
      optionsFramework: [
        {
          label: "Ant Design Vue2",
          value: "1",
        },
        {
          label: "Ant Design Vue3",
          value: "2",
        },
        {
          label: "React",
          value: "3",
        },
        {
          label: "Flutter",
          value: "4",
        },
      ],
    };
  },
  mounted() {
    let self = this;
    self.tagList();
    self.getFrameworkTree();
  },
  methods: {
    //验证项目编码格式
    validProjectCode(){
      let name = this.form.getFieldsValue().name;
      if(name!==undefined){
        let newName = name.trim();
        if(!/^([A-Z]([a-z0-9]{1,})){2,}/g.test(newName)){
          this.$message.error("项目编码必须是驼峰体,类似TestProject");
          this.form.setFieldsValue({"name":undefined});
        } else {
          if(newName.indexOf(" ")!==-1){
            this.$message.error("项目编码必须是驼峰体,类似TestProject");
            this.form.setFieldsValue({"name":undefined});
          } else {
            this.form.setFieldsValue({"name":newName});
          }  
        } 
      } 
      // 这个土方法留着
      // 判断name是否没填
      // if(name!==undefined){
      //   let newName = this.form.getFieldsValue().name.trim();
      //   let regList = newName.split(/[A-Z]/)
      //   let resReg = (/[A-Z]/.test(newName)) && newName.indexOf(" ")===-1
      //   //说明有至少两个大写字母而且不是全小写字母而且中间不能有空格
      //   if(regList.length>=3 && resReg){
      //     regList.map((item,index)=>{
      //       if(index!==0){
      //         if(!/[a-z0-9]{1,}/.test(item)){
      //           this.$message.error("项目编码必须是驼峰体,类似TestProject");
      //           this.form.setFieldsValue({"name":undefined});
      //           return false
      //         } else{
      //           this.form.setFieldsValue({"name":newName});
      //         }
      //       }
      //     })
      //     //说明只有一个或者没有大写字母
      //   } else {
      //     this.$message.error("项目编码必须是驼峰体,类似TestProject");
      //     this.form.setFieldsValue({"name":undefined});
      //   }
      // }
    },
    displayRender({ labels }) {
      return labels[labels.length - 1];
    },
    tagList() {
      let self = this;
      let tagList = [];
      projectApi.tagList({ pageSize: 1000, pageNo: 1, type: 0 }).then((res) => {
        console.log("tag查询", res.result.records);
        res.result.records.forEach((element) => {
          element.disabled = true;
          tagList.push({ value: element.id, label: element.name });
        });
        self.tags = tagList;
      });
    },
    getFrameworkTree() {
      frameworkApi.listAll().then(res => {
        console.log('res', res)
        this.frameworkList = res.result
        let frameworkOptions = {id: null}
        this.getChildren(frameworkOptions)
        this.frameworkOptions = frameworkOptions.children
        console.log('option', this.frameworkOptions)
        // _(res.result).filter(item => tem.parentId == null).each
      })
    },
    getChildren(obj){
      obj.children = _.filter(this.frameworkList, item => item.parentId == obj.id)
      if(obj.children.length > 0){
        obj.children.forEach(item => {
          this.getChildren(item)
        })
      }
    },
    handleChange(value) {
      // this.tagParams = {}
      console.log(`Selected: ${value}`);
    },
    onSubmit() {
      this.form.validateFields((err, values) => {
        if (!err) {
          this.addloading = true;
          let project = this.form.getFieldsValue();
          console.log('project', project)
          this.queryAdd(project);
        } else {
          this.$message.info("请填充必选项");
        }
      });
    },
    resetForm() {},
    clickTag(tag) {
      if (tag.disabled) {
        if (this.chooseTag.length < 6) {
          tag.disabled = !tag.disabled;
          this.chooseTag.push(tag);
        } else {
          this.$message.info("最多选择6个标签");
        }
      } else {
        for (let index in this.chooseTag) {
          if (tag.id == this.chooseTag[index].id) {
            this.chooseTag.splice(index, 1);
            tag.disabled = !tag.disabled;
          }
        }
      }
      console.log(this.chooseTag);
    },
    /**
     * 获取请求的参数
     */
    getTagParams() {
      this.tagParams = {
        dataType: "project",
        params: {
          pageNo: 1,
          pageSize: 10,
          column: "num",
          order: "desc",
          type: 0,
        },
      };
    },
    /**
     * 添加接口
     * @param {Object} params 添加的数据
     */
    queryAdd(params) {
      //全局定义一个加载效果
      const hide = this.$message.loading("正在创建项目，请等待", 0);
      params.frameworkId = params.frameworkId[params.frameworkId.length - 1]
      console.log("执行添加接口的方法", params);
      projectApi
        .add(Object.assign(this.addProjectParams, params))
        .then((res) => {
          if (res.success) {
            //取消全局定义的加载效果
            setTimeout(hide, 0);
            this.$message.success("添加成功");
            //取消按钮loading效果
            this.addloading = false;
            return this.$router.push({
              path: "component/list",
              query: { projectId: res.result.id },
            });
          }
          this.addloading = false;
          setTimeout(hide, 0);
          return this.$message.error(res.message);
        })
        .catch((error) => {
          this.addloading = false;
          console.log("添加失败,原因:", error);
        });
    },
    /**
     *  页面返回
     */
    pageBack() {
      this.$router.go(-1);
    },
    getRidoVal(val) {
      console.log("选中的权限", val);
    },
    getBuy() {
      console.log("点击了购买按钮");
    },
  },
};
</script>

<style lang="less" scoped>
.add-project {
  // width: 1400px;
  margin: 0 auto;
  margin-top: 100px;
  background-color: #f5f5f5;
  .add-project-form-item {
    .add-project-input {
      width: 624px;
      height: 44px;
      line-height: 44px;
    }
    .add-project-textarea {
      height: 177px;
    }
    .add-tag-block {
      .add-tag-item {
        display: inline-block;
        padding: 5px 10px;
        background: #ffffff;
        border: 1px solid #d9d9d9;
        border-radius: 4px;
        margin: 5px;
      }
      .active {
        background-color: #fd4734;
        color: #fff;
        border-color: #fd4734;
      }
    }
  }
  .add-project-bottom {
    margin-top: 85px;
    .add-project-button {
      width: 87px;
      height: 43px;
      margin-left: 10px;
    }
  }
  .tags__main--div {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
}

/deep/ .ant-form-item {
  display: flex;
  justify-content: center;
}
/deep/ .ant-form-item-control {
  width: 624px;
  line-height: 1.5vw;
}
/deep/ .add-tag-block {
  text-align: left;
}
/deep/ .ant-btn {
  // line-height: 2vw;
  font-weight: 500;
}
</style>
